import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone } from 'lucide-react';
import { CONTACT_INFO, NAV_LINKS } from '../../lib/constants';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-black/50 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block">
              <img 
                src="https://customer-assets.emergentagent.com/job_cinematic-studio-29/artifacts/lwsj55ca_STUDIOS.png" 
                alt="HYDROX STUDIOS" 
                className="h-14 w-auto"
              />
            </Link>
            <p className="mt-4 text-muted-foreground font-manrope text-sm leading-relaxed max-w-sm">
              Premium audio and video post-production studio for independent artists and creative brands.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-syne font-semibold text-white mb-4">Navigation</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-muted-foreground hover:text-white transition-colors font-manrope text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-syne font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  className="flex items-center gap-2 text-muted-foreground hover:text-white transition-colors font-manrope text-sm"
                >
                  <Mail size={16} />
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${CONTACT_INFO.phone}`}
                  className="flex items-center gap-2 text-muted-foreground hover:text-white transition-colors font-manrope text-sm"
                >
                  <Phone size={16} />
                  {CONTACT_INFO.phone}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT_INFO.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-muted-foreground hover:text-white transition-colors font-manrope text-sm"
                >
                  <Instagram size={16} />
                  @hydroxstudios
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground font-manrope text-sm">
            © {new Date().getFullYear()} HYDROX STUDIOS. All rights reserved.
          </p>
          <p className="text-muted-foreground/60 font-manrope text-xs">
            Premium Audio & Video Post-Production
          </p>
        </div>
      </div>
    </footer>
  );
};
